import { IInfinitePageParams } from 'services/types';

export interface IMessageBase {
  message: string;
  attachments: File[];
}
export interface ICreateThread extends IMessageBase {
  subject: string;
}
export interface ICreateMessage extends IMessageBase {
  threadId: string;
}

export interface IReadMessage {
  // accountId: string;
  messageId: string;
}

export interface IChatMessageAttachment {
  id: string;
  fileName: string;
  path: string;
  sizeInMB: number;
  createdAt: string;
  extension: string;
  mD5Hash: string;
}

export interface IChatMessage {
  id: string;
  messageThreadId: string;
  senderId: string;
  recipientId: string;
  body: string;
  attachments: IChatMessageAttachment[];
  readAt: string | null;
  messageCreatedAt: string;
}

export interface IChat {
  messageThreadId: string;
  labelId: string;
  subject: string;
  messages: IChatMessage[];
  messageThreadCreatedAt: string;
  hasUnreadMessage: boolean;
  messageThreadStatus: { id: THREAD_STATUS };
  lastMessage: IChatMessage;
}

export interface IChatMessagesSearchParams extends IInfinitePageParams {
  messageThreadId: string;
}

export enum THREAD_STATUS {
  open = 1,
  closed = 2,
}
